export default __webpack_public_path__ + "cddf90e5dc6a4a15a8ae707856606325.svg";